var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExtraBigCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1657,
    height: 1635,
    viewBox: "0 0 1657 1635",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1519.43 1135.41C1588.94 1053.01 1625.13 967.7 1628.61 881.586C1628.87 874.848 1629 868.11 1629 861.381C1629 704.083 1561.16 598.803 1435.31 533.781C1420.33 143.491 1223.11 0 891.523 0C546.38 0 186.477 225.103 186.477 652.529C186.477 653.567 186.496 654.605 186.496 655.643C102.846 724.335 52.1683 809.609 52.1683 910.935C52.1683 997.238 77.1389 1086.2 143.623 1171.02C51.989 1236.87 4.52037 1305.59 0.415233 1375.03C0.132119 1379.87 0 1384.72 0 1389.56C0 1607.54 299.807 1634.77 757.167 1634.77C1214.54 1634.77 1656.27 1571.94 1656.27 1353.95C1656.27 1281.11 1620.06 1205.61 1519.43 1135.41Z",
    fill: "#95AFCB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExtraBigCloud);
export default __webpack_public_path__ + "static/media/extra-big-cloud.76f1c1581baec205aefdf32e4477d4bc.svg";
export { ForwardRef as ReactComponent };